import { createApiCall } from 'lib/base';

const setUserStatus = createApiCall(
  'DASHBOARD/SET_USER_STATUS',
  ({ id, status }: { id: string; status: string }) => ({
    endpoint: `/api/admin/users/${id}/set-status`,
    method: 'POST',
    body: { status },
    notify: true,
    isReload: true,
  })
);

export default setUserStatus;
